import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { isNumber } from 'lodash';

import Money from '../../../../../common/money';
import Input from '../../../../../common/input';
import Multiselect from '../../../../../common/Multiselect';
import NoDataMessage from './NoDataMessage';

const ProductsStep = props => (
  <div>
    <div className="u-mb+" style={{ width: '200px' }}>
      <Multiselect
        title="Vendors"
        options={props.vendorOptions}
        onChange={props.handleVendorsChange}
      />
    </div>
    <ReactTable
      data={props.filteredProducts}
      showPagination={false}
      defaultPageSize={10000}
      minRows={0}
      className="c-table-new u-margin-0 c-overflow-visible c-no-hover"
      NoDataComponent={() => (
        <NoDataMessage
          hasProductsWithVendors={!!props.products && !!props.products.length}
          hasVendors={!!props.vendorOptions.length}
        />
      )}
      columns={[
        {
          Header: 'SKU',
          accessor: 'sku',
          Cell: ({ value }) => value || 'N/A',
        },
        {
          Header: 'Name',
          accessor: 'name',
        },
        {
          Header: 'Vendor',
          accessor: 'vendorName',
          Cell: ({ value }) => value || 'N/A',
        },
        {
          Header: 'Description',
          accessor: 'desc',
          Cell: ({ value }) => (
            <div className="u-text-trim">
              {value || 'N/A'}
            </div>
          ),
        },
        {
          Header: 'Supply Price',
          accessor: 'supplyPrice',
          Cell: ({ value }) => (
            <Money>{value}</Money>
          ),
        },
        {
          Header: 'Current inv.',
          accessor: 'inventory',
        },
        {
          Header: 'Low inv.',
          accessor: 'inventoryAlertAmount',
        },
        {
          Header: 'Quantity',
          id: 'quantity',
          Cell: row => (
            <Input
              className="c-input u-width-70"
              name={`products.${row.original.id}.quantity`}
              type="number"
              format={val => (isNumber(parseInt(val, 10)) ? parseInt(val, 10) : '')}
              parse={val => (isNumber(parseInt(val, 10)) ? parseInt(val, 10) : '')}
            />
          ),
        },
      ]}
    />
  </div>
);

ProductsStep.propTypes = {
  products: PropTypes.array.isRequired,
  filteredProducts: PropTypes.array.isRequired,
  vendorOptions: PropTypes.array.isRequired,
  handleVendorsChange: PropTypes.func.isRequired,
};

ProductsStep.defaultProps = {
  products: [],
};

export default ProductsStep;
